import React, { useEffect, useMemo, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Slide,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { LoadingButton } from "@mui/lab";
import { DataGrid } from "@mui/x-data-grid";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import DriveFileRenameOutlineRoundedIcon from "@mui/icons-material/DriveFileRenameOutlineRounded";
import { VisibilityOffRounded, VisibilityRounded } from "@mui/icons-material";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  createDocCategory,
  deleteDocItem,
  getAlldocCategory,
  updateDocCategory,
} from "../../../redux/Apps/Lawyerapp/DocumentSlice/DocumentSlice";
import { backend_api } from "../../../static/server";
import { compactGridStyle, pageScrollStyle } from "../../../styles/styles";
import { useDialog } from "../../DialogContext";

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="down" ref={ref} {...props} />
));

const DocumentCategoriForm = () => {
  const { showDialog, closeDialog } = useDialog();
  const dispatch = useDispatch();
  const [showList, setShowList] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [openCnfDelete, setOpenCnfDelete] = useState(false);
  const [deleteLoad, setDeleteLoad] = useState(false);
  const { token, teamMemberLawyerId } = useSelector((state) => state.user);
  const { allDocCategory, loading } = useSelector((state) => state.document);

  useEffect(() => {
    dispatch(
      getAlldocCategory({
        url: `${backend_api}documents/category/`,
        token: token,
        teamMemberLawyerId,
      })
    );
  }, [dispatch, token, teamMemberLawyerId]);

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      if (isEditMode) {
        await dispatch(
          updateDocCategory({
            url: `${backend_api}documents/category/${editId}/`,
            body: data,
            token,
          })
        ).unwrap();
        toast.success("Category updated successfully");
      } else {
        await dispatch(
          createDocCategory({
            url: `${backend_api}documents/category/`,
            body: data,
            token,
          })
        ).unwrap();
        toast.success("New category added successfully");
      }
      closeDialog();
      reset();
      dispatch(
        getAlldocCategory({
          url: `${backend_api}documents/category/`,
          token: token,
          teamMemberLawyerId,
        })
      );
    } catch (error) {
      toast.error(
        isEditMode ? "Failed to update category" : "Failed to create category"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const toggleShowList = () => {
    setShowList((prev) => !prev);
  };

  const handleEditCategory = (item) => {
    setIsEditMode(true);
    setEditId(item?.id);
    setValue("category_name", item?.row?.category_name);
  };

  const handleDelete = (id) => {
    setDeleteId(id);
    setOpenCnfDelete(true);
  };

  const handleDeleteCategory = async () => {
    setDeleteLoad(true);
    try {
      await dispatch(
        deleteDocItem({
          url: `${backend_api}documents/category/${deleteId}/`,
          token: token,
        })
      ).unwrap();
      toast.success("Category deleted successfully");
      dispatch(
        getAlldocCategory({
          url: `${backend_api}documents/category/`,
          token: token,
          teamMemberLawyerId,
        })
      );
    } catch (error) {
      toast.error(error?.message || "Failed to delete category");
    } finally {
      setDeleteLoad(false);
      setOpenCnfDelete(false);
    }
  };

  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      sortable: false,
      headerAlign: "left",
      renderCell: (item) => (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: "0.2rem ",
              width: "100%",
            }}
          >
            <Tooltip title="Edit">
              <IconButton
                color="primary"
                size="small"
                onClick={() => {
                  handleEditCategory(item);
                }}
              >
                <DriveFileRenameOutlineRoundedIcon sx={{ fontSize: "1rem" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton
                color="primary"
                size="small"
                aria-label="more"
                onClick={() => handleDelete(item?.id)}
              >
                <DeleteRoundedIcon sx={{ fontSize: "1rem" }} />
              </IconButton>
            </Tooltip>
          </Box>
        </>
      ),
    },
    { field: "category_name", headerName: "Category Name", flex: 1 },
  ];

  const rows = useMemo(() => {
    if (!Array.isArray(allDocCategory)) {
      console.error("allDocCategory is not an array:", allDocCategory);
      return [];
    }
    return (
      allDocCategory?.map((item) => ({
        id: item?.id ?? "-",
        category_name: item?.category_name ?? "-",
      })) ?? []
    );
  }, [allDocCategory]);

  return (
    <>
      <Box sx={{ position: "relative" }}>
        <Box sx={{ pt: "1rem", px: "1rem" }}>
          <Accordion
            expanded={showList}
            onChange={toggleShowList}
            sx={{ p: 0, boxShadow: "none", border: "1px solid #e5e5e5" }}
          >
            <AccordionSummary
              expandIcon={
                showList ? (
                  <VisibilityOffRounded sx={{ fontSize: "1rem", margin: 0 }} />
                ) : (
                  <VisibilityRounded sx={{ fontSize: "1rem", margin: 0 }} />
                )
              }
              sx={{
                padding: "0rem 0.5rem",
                minHeight: "1.5rem !important",
                height: "1.5rem",
                "& .MuiAccordionSummary-content": {
                  margin: 0,
                  minHeight: "1.5rem",
                },
              }}
            >
              <Typography
                component="span"
                sx={{ fontSize: "0.8rem", fontWeight: 600 }}
              >
                Exist Categories
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                padding: 0,
                height: "250px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ height: "100%", width: "100%" }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  loading={loading}
                  pageSize={30}
                  slotProps={{
                    loadingOverlay: {
                      variant: "skeleton",
                      noRowsVariant: "skeleton",
                      rowCount: 30,
                    },
                  }}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 30 } },
                  }}
                  disableRowSelectionOnClick
                  disableSelectionOnClick
                  sx={{
                    ...compactGridStyle,
                    height: "100%",
                    width: "100%",
                    "& .MuiDataGrid-main": {
                      overflow: "auto",
                      ...pageScrollStyle,
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                    },
                    "& .MuiDataGrid-footerContainer": {
                      position: "sticky",
                      bottom: 0,
                      zIndex: 1,
                      backgroundColor: "#fff",
                    },
                  }}
                />
              </div>
            </AccordionDetails>
          </Accordion>
        </Box>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              p: "1rem",
            }}
          >
            <Controller
              name="category_name"
              control={control}
              defaultValue=""
              rules={{ required: "Category Name is required" }}
              render={({ field }) => (
                <TextField
                  size="small"
                  {...field}
                  label={
                    <span>
                      Category Name<span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  fullWidth
                  error={!!errors?.category_name}
                  helperText={errors?.category_name?.message}
                />
              )}
            />
          </Box>

          <Box
            sx={{
              height: "fit-content",
              borderTop: "1px solid #ddd",
              position: "sticky",
              bottom: 0,
              backdropFilter: "blur(10px)",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              p: "0.5rem",
              zIndex: 1000,
              gap: "1rem",
            }}
          >
            <Button size="small" variant="outlined" onClick={closeDialog}>
              Cancel
            </Button>
            <LoadingButton
              loading={isSubmitting}
              variant="contained"
              color="primary"
              type="submit"
              size="small"
            >
              {isEditMode ? "Update category" : "Save category"}
            </LoadingButton>
          </Box>
        </form>
      </Box>
      <Dialog
        open={openCnfDelete}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setOpenCnfDelete(false)}
      >
        <DialogTitle>
          Sure you want to delete this document category
        </DialogTitle>
        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={() => setOpenCnfDelete(false)}
          >
            Cancel
          </Button>
          {deleteLoad ? (
            <LoadingButton size="small" loading variant="contained">
              Delete
            </LoadingButton>
          ) : (
            <Button
              size="small"
              variant="contained"
              color="error"
              onClick={handleDeleteCategory}
            >
              Delete
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DocumentCategoriForm;
